export default {
  isFecthing: (state) => state.fetching,
  cashWithdraw: (state) => state.cashWithdraw,
  getResponse: (state) => state.response,
  afiliasiSet: (state) => state.afiliasiSet,
  lastWithdraw: (state) => state.lastWithdraw,
  mutasiSaldo: (state) => state.mutasiSaldo,
  withdrawHistory: (state) => state.withdrawHistory,
  withdrawHistoryTotal: (state) => state.withdrawHistoryTotal,
  afiliated: (state) => state.afiliated,
  afiliatedTotal: (state) => state.afiliatedTotal,
  listBank: (state) => state.listBank,
  pagination: (state) => state.pagination,
  isLoadMore: (state) => state.loadMore,
  totalWithdraw: (state) => state.totalWithdraw,
  detailOwner: (state) => state.detailOwner,
};
